import React from 'react'

/**
 * The product visual, drawn in CSS rather than licensed: a navy card with a
 * gold chip and contactless mark, floating over a stack of translucent
 * sheets. Nothing to download, crisp at any density, and it carries the
 * brand colours — which no stock illustration did.
 *
 * Shared by the Services page and the home hero so both read as one system.
 */
const CardArt = ({ className = '' }) => (
  <figure className={`svcArt ${className}`.trim()} aria-hidden="true">
    <span className="svcArt__mesh" />
    <span className="svcArt__plane svcArt__plane--far" />
    <span className="svcArt__plane svcArt__plane--near" />
    <span className="svcArt__card">
      <span className="svcArt__chip" />
      <span className="svcArt__wave" />
      <span className="svcArt__strip" />
      <span className="svcArt__shine" />
    </span>
  </figure>
)

export default CardArt
